module.exports = __webpack_public_path__ + "static/media/RightArrowFillBlack.09a9c142.svg";